import React from "react"
import Footer from "./Footer"
import Header from "./Header"
import PDCategoryView from "../components/PDCategoryView"
import PrimaryManual from "../images/primary-manual.jpg"
import PowerpointLogo from "../images/powerpoint-icon.svg"
import PDFLogo from "../images/pdf.svg"

class PrimaryProfessionalDevelopment extends React.Component {
  state = {
    view: {
      title: "Primary Professional Development",
      parentURL: "/professional-development",
      parentName: "professional development",
      categories: [
        {
          name: "Training manual",
          file: PrimaryManual,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/primary/primary-manual.pdf",
        },
        {
          name: "Presentations",
          fileType: PowerpointLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/primary/PPP/",
          files: [
            { name: "Expectations and Outcomes", file: "P1.1.1.pptx" },
            { name: "How we'll work together", file: "P1.1.2.pptx" },
            { name: "Teacher Development Overview", file: "P1.1.3.pptx" },
            { name: "Teaching vs Training", file: "P1.1.4.pptx" },
            { name: "Guided self-discovery", file: "P1.2.1.pptx" },
            { name: "Material Overview", file: "P1.2.2.pptx" },
            { name: "Defining Objectives and Outcomes", file: "P1.2.3.pptx" },
            {
              name: "Determining the needs of your teachers",
              file: "P1.2.4.pptx",
            },
            { name: "Cognitive Development", file: "P1.3.1.pptx" },
            { name: "Approaches to Teaching", file: "P1.3.2.pptx" },
            { name: "Outcomes for your workshops", file: "P1.3.3.pptx" },
            {
              name: "An Overview of Training Methodology",
              file: "P1.3.4.pptx",
            },
            { name: "An Overview of Phonics", file: "P1.4.1.pptx" },
            { name: "Synthetic Phonics in your classes", file: "P1.4.2.pptx" },
            {
              name: "Training Methodology – practice and evaluation",
              file: "P1.4.3.pptx",
            },
            { name: "The Training Life Cycle", file: "P1.4.4.pptx" },
            { name: "Lesson planning – a discussion", file: "P1.5.1.pptx" },
            {
              name: "Lesson planning – practice and evaluation",
              file: "P1.5.2.pptx",
            },
            { name: "Agreeing the Workshops", file: "P1.5.3.pptx" },
            { name: "Planning a Workshop", file: "P1.5.4.pptx" },
            {
              name: "Microteaching – introduction and preparation",
              file: "P1.6.1.pptx",
            },
            { name: "Microteaching 1", file: "P1.6.2.pptx" },
            { name: "Microtraining 1 – preparation", file: "P1.6.3.pptx" },
            {
              name: "Microtraining 1 – delivery and feedback",
              file: "P1.6.4.pptx",
            },
            { name: "Teaching Writing", file: "P2.1.1.pptx" },
            {
              name: "Writing Activities in 21st Century English for Libya",
              file: "P2.1.2.pptx",
            },
            { name: "Designing a Training Kit", file: "P2.1.3.pptx" },
            { name: "Four-day training. An overview.", file: "P2.1.4.pptx" },
            {
              name: "Self-awareness and Reflective Practice",
              file: "P2.2.1.pptx",
            },
            {
              name: "Self-awareness and Reflection – action plans",
              file: "P2.2.2.pptx",
            },
            { name: "Workshop Design and Evaluation", file: "P2.2.3.pptx" },
            {
              name: "Full-length workshop design and evaluation",
              file: "P2.2.4.pptx",
            },
            {
              name: "A comparison with previous course materials",
              file: "P2.3.1.pptx",
            },
            { name: "Adapting my approach", file: "P2.3.2.pptx" },
            { name: "Microtraining 2 – preparation", file: "P2.3.3.pptx" },
            {
              name: "Microtraining 2 – delivery and feedback",
              file: "P2.3.4.pptx",
            },
            {
              name: "Microteaching 2 – collaborative preparation and discussion",
              file: "P2.4.1.pptx",
            },
            {
              name: "Microteaching 2 – delivery and feedback",
              file: "P2.4.2.pptx",
            },
            {
              name: "Methodology – key areas for improvement",
              file: "P2.4.3.pptx",
            },
            {
              name: "Strategies for changing teachers' approaches",
              file: "P2.4.4.pptx",
            },
            { name: "Teaching Form and Meaning", file: "P2.5.1.pptx" },
            { name: "Teaching Vocabulary", file: "P2.5.2.pptx" },
            { name: "Training Adult Teachers", file: "P2.5.3.pptx" },
            { name: "Strategies for Training Adults", file: "P2.5.4.pptx" },
            { name: "Why and how do we tell stories?", file: "P3.1.1.pptx" },
            {
              name: "Storytelling in 21st Century English for Libya",
              file: "P3.1.2.pptx",
            },
            {
              name: "The active and collaborative learning environment",
              file: "P3.1.3.pptx",
            },
            {
              name: "Evaluation, Reporting and Oral Feedback – process and language",
              file: "P3.1.4.pptx",
            },
            {
              name: "Effective classroom management and language",
              file: "P3.2.1.pptx",
            },
            {
              name: "Classroom management and language – into practice",
              file: "P3.2.2.pptx",
            },
            { name: "Setting up Microtraining", file: "P3.2.3.pptx" },
            { name: "Microtraining roleplays", file: "P3.2.4.pptx" },
            { name: "Speaking in Primary ELT", file: "P3.3.1.pptx" },
            {
              name: "Speaking Activities in 21st Century English for Libya",
              file: "P3.3.2.pptx",
            },
            { name: "Microtraining 3 – preparation", file: "P3.3.3.pptx" },
            {
              name: "Microtraining 3 – delivery and feedback",
              file: "P3.3.4.pptx",
            },
            {
              name: "Microtraining 3 – collaborative preparation and discussion",
              file: "P3.4.1.pptx",
            },
            {
              name: "Microteaching 3 – delivery and feedback",
              file: "P3.4.2.pptx",
            },
            { name: "Full workshop preparation", file: "P3.4.3.pptx" },
            { name: "Full workshop preparation", file: "P3.4.4.pptx" },
            {
              name: "The Why and How of Primary Assessment",
              file: "P3.5.1.pptx",
            },
            {
              name: "Assessment in 21st Century English for Libya",
              file: "P3.5.2.pptx",
            },
            { name: "Full workshop preparation", file: "P3.5.3.pptx" },
            { name: "Full workshop preparation", file: "P3.5.4.pptx" },
            { name: "Bringing it all together", file: "P3.6.1.pptx" },
            { name: "Presentations and Questions", file: "P3.6.2.pptx" },
            { name: "Poster presentations and display", file: "P3.6.3.pptx" },
          ],
        },
        {
          name: "Handouts",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/primary/Handouts/",
          files: [
            {
              name: "Handout Lesson Observation",
              file: "Handout-Lesson-Observation.pdf",
            },
            { name: "Handout P1.3.2 cards", file: "Handout-P1.3.2-cards.pdf" },
            { name: "Handout P1.4.1", file: "Handout-P1.4.1.pdf" },
            { name: "Handout P1.5.1", file: "Handout-P1.5.1.pdf" },
            { name: "Handout P2.1.4.1", file: "Handout-P2.1.4.1.pdf" },
            { name: "Handout P2.1.4.2", file: "Handout-P2.1.4.2.pdf" },
            { name: "Handout P2.5.3", file: "Handout-P2.5.3.pdf" },
            { name: "Handout P2.5.4.1", file: "Handout-P2.5.4.1.pdf" },
            { name: "Handout P2.5.4.2", file: "Handout-P2.5.4.2.pdf" },
            { name: "Handout P3.1.3", file: "Handout-P3.1.3.pdf" },
            { name: "Handout P3.2.2", file: "Handout-P3.2.2.pdf" },
            {
              name: "Handout Peer Feedback",
              file: "Handout-Peer-feedback.pdf",
            },
            {
              name: "Handout Workshop Observations",
              file: "Handout-Workshop-Observations.pdf",
            },
          ],
        },
        {
          name: "Videos",
          embedPath: "https://player.vimeo.com/video/",
          files: [
            { title: "An overview of phonics", id: "291068499" },
            {
              title: "Assessment language in 21st English for Libya",
              id: "291286810",
            },
            { title: "Cognitive development", id: "291286831" },
            { title: "Effective classroom management", id: "291286861" },
            { title: "Expectations & outcomes", id: "291286894" },
            { title: "Getting to know each other", id: "291286907" },
            { title: "Giving effective instructions", id: "291286914" },
            { title: "Group session on phonics by Nele Noe", id: "291286979" },
            {
              title: "Guided Self-discovery & Material Overview",
              id: "291287003",
            },
            { title: "How we'll work together", id: "291287014" },
            { title: " Lesson planning - a discussion", id: "291287025" },
            { title: "Microteaching 1 – Introduction", id: "291287060" },
            { title: "Mixed Ability", id: "291287081" },
            { title: "Phonics", id: "291287096" },
            { title: "Reading", id: "291287123" },
            { title: "Speaking in Primary ELT", id: "291287136" },
            {
              title: "Storytelling in 21st Century English for Libya",
              id: "291287142",
            },
            {
              title: "Teacher Development Overview and Reflection",
              id: "291287149",
            },
            { title: "Teaching listening", id: "291287171" },
            { title: "Teaching vocabulary", id: "291287185" },
            { title: "Teaching vs. Training", id: "291287195" },
            { title: "Teaching writing", id: "291287220" },
            {
              title: "The why and how of Primary ELT assessment",
              id: "291287230",
            },
            {
              title: "Training methodology-practice and evaluation",
              id: "291287241",
            },
            {
              title: "Welcoming speech by Christopher Graham",
              id: "291287272",
            },
            {
              title: "Welcoming Speech by Dr. Massouda ElAswad",
              id: "291111474",
            },
            { title: "Welcoming Speech by Dr. Rida Ismail", id: "291111485" },
            { title: "Why and how do we tell stories", id: "291287299" },
          ],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <PDCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default PrimaryProfessionalDevelopment



// WEBPACK FOOTER //
// ./src/components/PrimaryProfessionalDevelopment.js